import type { PlaceCoreData } from "@/components/admin/place-core/placeCoreSchema";

/**
 * Form draft shape for dirty-detection.
 */
export interface PlaceDraft {
  name?: string;
  slug?: string;
  municipality?: string;
  landskap?: string;
  county?: string;
  address_text?: string;
  description_short?: string;
  website?: string;
  instagram?: string;
  phone?: string;
  contact_website?: string;
  contact_instagram?: string;
  contact_phone?: string;
  contact_email?: string;
  lat?: number | null;
  lng?: number | null;
  status?: string;
  tags?: string[];
  place_core?: PlaceCoreData;
}

export function normalizePlaceDraft(draft: PlaceDraft): Record<string, unknown> {
  return {
    name: draft.name ?? "",
    slug: draft.slug ?? "",
    municipality: draft.municipality ?? "",
    landskap: draft.landskap ?? "",
    county: draft.county ?? "",
    address_text: draft.address_text ?? "",
    description_short: draft.description_short ?? "",
    website: draft.website ?? "",
    instagram: draft.instagram ?? "",
    phone: draft.phone ?? "",
    contact_website: draft.contact_website ?? "",
    contact_instagram: draft.contact_instagram ?? "",
    contact_phone: draft.contact_phone ?? "",
    contact_email: draft.contact_email ?? "",
    lat: draft.lat ?? null,
    lng: draft.lng ?? null,
    status: draft.status ?? "draft",
    tags: [...(draft.tags || [])].sort(),
    place_core: {
      vibe: draft.place_core?.vibe ?? "",
      intents: [...(draft.place_core?.intents || [])].sort(),
      seasons: [...(draft.place_core?.seasons || [])].sort(),
      duration: draft.place_core?.duration ?? "",
      did_you_know: draft.place_core?.did_you_know ?? "",
      area: draft.place_core?.area ?? "",
      offers: [...(draft.place_core?.offers || [])].sort(),
      offers_other: draft.place_core?.offers_other ?? "",
      shop_categories: [...(draft.place_core?.shop_categories || [])].sort(),
    },
  };
}

export function computeDirty(initial: PlaceDraft, current: PlaceDraft): boolean {
  return (
    JSON.stringify(normalizePlaceDraft(initial)) !==
    JSON.stringify(normalizePlaceDraft(current))
  );
}
